import { Box, Flex, Separator, Text } from "@radix-ui/themes";
import { GondolaChangeGroupsFilterSection } from "./gondola-change-groups-filter-section";
import AnnotatedCartSection from "./annotated-cart-section";

export function FilterSection() {
  return (
    <Flex
      direction="column"
      flexGrow="1"
      flexBasis="1"
      height="100%"
      maxHeight="100%"
    >
      <Box>
        <Text size="2" weight="bold" as="p" m="2">
          Filter
        </Text>
      </Box>
      <AnnotatedCartSection />
      <Separator size="4" />
      <GondolaChangeGroupsFilterSection />
    </Flex>
  );
}
